import { render, staticRenderFns } from "./ProcessFlowLabelPrintRestriction.vue?vue&type=template&id=30d4fe98&"
import script from "./ProcessFlowLabelPrintRestriction.vue?vue&type=script&lang=js&"
export * from "./ProcessFlowLabelPrintRestriction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports